import React, {useEffect, useState, useRef} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {ApplicationState} from "../store";
import {APIState} from "../store/API/types";
import {AlertState} from "../store/alerts/types";
import { chooseService, getStreamFromCamera } from "../utils";
import UnSupportedFormatComponent from "../components/reusable/UnSupportedFormatComponent";
import LiveGetStreamComponent from "../components/livemode/LiveGetStreamComponent";


type errorState = {
    error: boolean,
    msg: string
};

const AlertPaneLiveContainer = ( ) => {
    const [ streamStatus, setStreamStatus ] = useState<errorState>({error: false, msg: ''});
    const [ currentAlertStream, setCurrentAlertStream ] = useState<any>(null);
    const { cameras } = useSelector<ApplicationState, APIState>(state => state.API);
    const { selectedEvent } = useSelector<ApplicationState, AlertState>(state => state.alerts);
    const ref = useRef<HTMLDivElement>(null);
    const id = selectedEvent ? selectedEvent.where_id : null;

    useEffect(() => {
        if (id && selectedEvent) {
            const { error, stream } = chooseService(
              () => getStreamFromCamera(cameras, selectedEvent.where_id, ref),
              () => ({error: false, stream: null})
            );

            if (!error) {
                setStreamStatus({error: false, msg: stream});
                setCurrentAlertStream(stream);
            } else {
                setStreamStatus({error: true, msg: stream})
            }
        }
    }, [id]);
    
    return <div className={'live-stream-wrapper'} ref={ref}>
        {
            (selectedEvent && streamStatus.error) && <UnSupportedFormatComponent data={streamStatus.msg}/>
        }
        {
            (selectedEvent && currentAlertStream && id && !streamStatus.error) && <LiveGetStreamComponent   stream={currentAlertStream}
                                                                pane={1}
                                                                cameraId={id}
            />
        }
    </div>
};

export default AlertPaneLiveContainer